module.exports = __webpack_public_path__ + "assets/img/Overcame-this-obstacle.414ddf45.jpg";